import React from 'react';
import { Show, SimpleShowLayout, TextField, EditButton } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import { ViewTitle } from '../ui';
import { UserProfileTitle } from './UserProfileTitle';
export const UserProfileShow = props => {
    const classes = useStyles(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(ViewTitle, null),
        React.createElement(Show, Object.assign({}, props, { title: React.createElement(UserProfileTitle, Object.assign({ actions: React.createElement(EditButton, null) }, props)), actions: null }),
            React.createElement(SimpleShowLayout, { className: classes.root },
                React.createElement(TextField, { className: classes.field, source: "userName" }),
                React.createElement(TextField, { className: classes.field, source: "lastName" }),
                React.createElement(TextField, { className: classes.field, source: "firstName" }),
                React.createElement(TextField, { className: classes.field, source: "email" })))));
};
const useStyles = makeStyles(theme => ({
    root: {
        padding: `${theme.spacing(4)}px !important`,
    },
    field: {
        width: 456,
    },
}), {
    name: 'Layer7UserProfileShow',
});
//# sourceMappingURL=UserProfileShow.js.map